import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useEffect, useState } from 'react';
import { getSoonExpiredProducts } from '../warehouse/WarehouseService';
import { useAlert } from 'react-alert';
import { SoonExpiredProductsTable } from './SoonExpiredProductsTable';
import { RolesValidator } from '../../../../validations/RolesValidator';
import { ROLE } from '../../../../utils/ROLE';
import './HomePage.css';
import { getSoonExpiredContracts } from '../partners/PartnersService';
import { SoonExpiredContractsTable } from './SoonExpiredContractsTable';

export const HomePage = () => {

    const { t } = useTranslation();
    const alert = useAlert();
    const selectorUsername = useSelector((state) => state.login.fullName);
    const [soonExpiredProducts, setSoonExpiredProducts] = useState([]);
    const canViewProducts = RolesValidator([ROLE.DIETIST, ROLE.MANAGER]);
    const [soonExpiredContracts, setSoonExpiredContracts] = useState([]);
    const canViewContracts = RolesValidator([ROLE.DIETIST, ROLE.DIRECTOR]);

    useEffect(() => {
        load();
    }, []);

    const load = () => {
        if (canViewProducts) {
            getSoonExpiredProducts()
                .then((response) => setSoonExpiredProducts(response.data))
                .catch(() => alert.error(t('alert:loadingError')));
        }
        if (canViewContracts) {
            getSoonExpiredContracts()
                .then((response) => setSoonExpiredContracts(response.data))
                .catch(() => alert.error(t('alert:loadingError')));
        }
    };
    return (
        <div className={'home-page-container'}>
            <h3 className={'center'}>{t('hello', { name: selectorUsername })}</h3>
            {canViewProducts
                ? <SoonExpiredProductsTable products={soonExpiredProducts}></SoonExpiredProductsTable>
                : <></>
            }
            {canViewContracts
                ? <SoonExpiredContractsTable contracts={soonExpiredContracts}></SoonExpiredContractsTable>
                : <></>
            }
        </div>
    );
};
